import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { SxProps, Tooltip, Typography } from "@mui/material";
import React from "react";

interface AiGeneratedRecipeNameProps {
  name: string;
  sx?: SxProps;
}

export const AiGeneratedRecipeName = ({ name, sx }: AiGeneratedRecipeNameProps) => {
  return (
    <>
      <Tooltip
        title={
          <>
            <strong>{name}</strong>
            <br />
            <span>This recipe was built using AI!</span>
          </>
        }
      >
        <Typography sx={sx}>
          {name}
          <AutoAwesomeIcon sx={{ fontSize: "16px" }} />
        </Typography>
      </Tooltip>
    </>
  );
};
